"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./HttpError.js");class e extends r.HttpError{constructor(r,e,t){super(r,"Data conflict error occurred.",e,t)}}exports.ConflictError=e;
//# sourceMappingURL=ConflictError.js.map
